import React from 'react';
import { Mail } from 'lucide-react';
import { contactInfo } from '../mock';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-purple-500/30">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_urban-mural-tech/artifacts/1e9u8vwf_file_00000000e66871f7bd252bbaa40acdec.png"
              alt="Medusai Graphics Unlimited Logo"
              className="h-16 md:h-20 w-auto hover:scale-105 transition-transform duration-300"
            />
          </div>

          {/* Navigation Links - Desktop */}
          <nav className="hidden md:flex items-center gap-6">
            <a href="#services" className="text-gray-300 hover:text-purple-400 transition-colors font-medium">
              Services
            </a>
            <a href="#gallery" className="text-gray-300 hover:text-purple-400 transition-colors font-medium">
              Gallery
            </a>
            <a href="#how-it-works" className="text-gray-300 hover:text-purple-400 transition-colors font-medium">
              Process
            </a>
            <a href="#pricing" className="text-gray-300 hover:text-purple-400 transition-colors font-medium">
              Pricing
            </a>
            <a href="#contact" className="text-gray-300 hover:text-purple-400 transition-colors font-medium">
              Contact
            </a>
          </nav>

          {/* Contact Info - Desktop */}
          <div className="hidden lg:flex items-center gap-4">
            <a 
              href={`mailto:${contactInfo.emailAlt}`}
              className="px-4 py-2 bg-purple-600 text-white rounded-full font-bold text-sm hover:bg-purple-700 transition-all hover:scale-105"
            >
              Get a Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-purple-400">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
